import * as React from 'react';
import './style.scss';
import { TravellerCategory } from '../../../models/traveller-category.enum';
import { TranslationService } from '../../../services/translation.service';
import RadioFormGroup from '../RadioFormGroup';
import ValidationInfo from '../../../validation/validation-info';

function TravellerCategorySelector({
  renderAsDropdown = false,
  selectedTravellerCategory,
  onChange,
}: {
  renderAsDropdown: boolean;
  selectedTravellerCategory: TravellerCategory;
  onChange: (category: TravellerCategory) => void;
}) {
  const randomIndexSuffix: number = Math.floor(Math.random() * Math.floor(Number.MAX_SAFE_INTEGER ? Number.MAX_SAFE_INTEGER : 9007199254740991)); // IE 11 polyfill

  function handleCategoryChange(value: TravellerCategory) {
    onChange(value);
  }

  return (
    <div className="traveller-category-selector">
      {renderAsDropdown ? (
        <div>
          <label htmlFor={`traveller-category-${randomIndexSuffix}`} className="form-label">
            {TranslationService.get('common.travellercategory')}
          </label>
          <select
            value={selectedTravellerCategory}
            className="w-100 ms-0 me-0 form-select"
            onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
              handleCategoryChange(e.target.value as TravellerCategory);
            }}
            id={`traveller-category-${randomIndexSuffix}`}
            name={`traveller-category-${randomIndexSuffix}`}
          >
            <option value={TravellerCategory.adult}>{TranslationService.get('common.adult')}</option>
            <option value={TravellerCategory.youth}>{TranslationService.get('common.youth')}</option>
          </select>
        </div>
      ) : (
        <RadioFormGroup
          id={`traveller-category-${randomIndexSuffix}`}
          className="mb-0"
          labelText={TranslationService.get('common.travellercategory')}
          options={[
            { value: TravellerCategory.adult, text: TranslationService.get('common.adult') },
            { value: TravellerCategory.youth, text: TranslationService.get('common.youth') },
          ]}
          rowLayoutSmUp={true}
          state={{ value: selectedTravellerCategory, validationInfo: new ValidationInfo() }}
          onChange={(value: string) => onChange(value as TravellerCategory)}
        />
      )}
    </div>
  );
}

export default TravellerCategorySelector;
